import { useState } from 'react';

import { Grid } from '@mui/material';
import { FieldOwnerState } from '@mui/x-date-pickers';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';

import { StoreAutoComplete, TipoGradeAutoComplete } from 'components/autocompletes';
import { CissAutoComplete } from 'components/autocompletes/CissAutoComplete';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

const filterPedidoOptions = [
    {
        idOptionPedido: 1,
        dsNomeExibicao: 'Ambos',
        vlOptionPedido: null,
    },
    {
        idOptionPedido: 2,
        dsNomeExibicao: 'Sim',
        vlOptionPedido: true,
    },
    {
        idOptionPedido: 3,
        dsNomeExibicao: 'Não',
        vlOptionPedido: false,
    },
];

export function FilterGrade() {
    const [filterLoja, setFilterLoja] = useState<FilterValuesProps>({
        property: 'cdLoja',
        operator: 'eq',
        value: null,
        idProperty: 'cdLoja',
    });

    const [filterGrade, setFilterGrade] = useState<FilterValuesProps>({
        property: 'idTipoGrade',
        operator: 'in',
        value: [],
        idProperty: 'idTipoGrade',
    });

    const [filterPedido, setFilterPedido] = useState<FilterValuesProps>({
        property: 'fgPedido',
        operator: 'eq',
        value: null,
        idProperty: 'vlOptionPedido',
    });

    const [filterDataLimitePedidoInterval, setFilterDataLimitePedidoInterval] = useState<FilterValuesProps>({
        property: 'dtLimitePedido',
        operator: 'bt',
        startDate: null,
        endDate: null,
    });

    const [filterDataEntregaInterval, setFilterDataEntregaInterval] = useState<FilterValuesProps>({
        property: 'dtEntrega',
        operator: 'bt',
        startDate: null,
        endDate: null,
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterLoja, setter: setFilterLoja },
                { value: filterPedido, setter: setFilterPedido },
                { value: filterGrade, setter: setFilterGrade },
                { value: filterDataLimitePedidoInterval, setter: setFilterDataLimitePedidoInterval },
                { value: filterDataEntregaInterval, setter: setFilterDataEntregaInterval },
            ]}
        >
            <Grid size={{ lg: 6 }}>
                <StoreAutoComplete fgTipoLoja value={filterLoja.value} onChange={(e, value) => setFilterLoja({ ...filterLoja, value })} />
            </Grid>
            <Grid size={{ lg: 3 }}>
                <TipoGradeAutoComplete multiple value={filterGrade.value} onChange={(e, value) => setFilterGrade({ ...filterGrade, value })} />
            </Grid>
            <Grid size={{ lg: 3 }}>
                <CissAutoComplete
                    value={filterPedido.value}
                    options={filterPedidoOptions}
                    onChange={(e, value) => {
                        setFilterPedido({ ...filterPedido, value });
                    }}
                    isOptionEqualToValue={(option, value) => option && value && option.idOptionPedido === value.idOptionPedido}
                    multiple={false}
                    optionStringTemplate={'{dsNomeExibicao}'}
                    selectedStringTemplate={'{dsNomeExibicao}'}
                    label={'Possui pedido'}
                />
            </Grid>
            <Grid sx={{ width: '100%' }} size={{ lg: 6 }}>
                <DateRangePicker
                    value={[filterDataLimitePedidoInterval.startDate ?? null, filterDataLimitePedidoInterval.endDate ?? null]}
                    onChange={([startDate, endDate]) => {
                        setFilterDataLimitePedidoInterval((oldState: FilterValuesProps) => ({
                            ...oldState,
                            startDate,
                            endDate,
                        }));
                    }}
                    slots={{ field: MultiInputDateRangeField }}
                    slotProps={{
                        field: { dateSeparator: 'até' },
                        textField: ({ position }: FieldOwnerState & { position?: 'start' | 'end' }) => ({
                            label: position === 'start' ? 'Data de limite pedido início' : 'Data de limite pedido fim',
                            autoComplete: 'off',
                        }),
                    }}
                />
            </Grid>
            <Grid sx={{ width: '100%' }} size={{ lg: 6 }}>
                <DateRangePicker
                    value={[filterDataEntregaInterval.startDate ?? null, filterDataEntregaInterval.endDate ?? null]}
                    onChange={([startDate, endDate]) => {
                        setFilterDataEntregaInterval((oldState: FilterValuesProps) => ({
                            ...oldState,
                            startDate,
                            endDate,
                        }));
                    }}
                    enableAccessibleFieldDOMStructure={false}
                    slots={{ field: MultiInputDateRangeField }}
                    slotProps={{
                        field: { dateSeparator: 'até' },
                        textField: ({ position }: FieldOwnerState & { position?: 'start' | 'end' }) => ({
                            label: position === 'start' ? 'Data de entrega início' : 'Data de entrega fim',
                            autoComplete: 'off',
                        }),
                    }}
                />
            </Grid>
        </Filter>
    );
}
